import {
  MerchantAccount,
  MerchantAccountFilters,
} from "@/types/merchant-account";

import { listMerchantAccounts } from "./merchant-account";

export const merchantAccountQueryKeys = {
  all: ["billing", "merchant-account"] as const,
  list: (filters?: MerchantAccountFilters) =>
    [...merchantAccountQueryKeys.all, "list", filters] as const,
};

export const merchantAccountQueryOptions = {
  list: (filters?: MerchantAccountFilters) => ({
    queryKey: merchantAccountQueryKeys.list(filters),
    queryFn: () => listMerchantAccounts(filters),
    select: (data: MerchantAccount[] | null) => data ?? [],
  }),
  default: () => ({
    queryKey: [...merchantAccountQueryKeys.all, "default"] as const,
    queryFn: async () => {
      const accounts = await listMerchantAccounts();
      if (!accounts) return null;
      return (
        accounts.find((account) => account.isDefault) || accounts[0] || null
      );
    },
    select: (data: MerchantAccount | null) => data,
  }),
};
